import axios from "axios";
import SideNavbar from "../../components/common/SideNavbar";
import TopNavbar from "../../components/common/TopNavbar";
import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { Button, Spinner, Modal, Accordion } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import DataTable from "react-data-table-component";
import { shipmentUploadsTableCustomStyles, importExportTableCustomStyles } from "../../utils/TableCustomStyles";
import "../../components/css/StepperForm.css";
import "../../components/css/ToolTipForm.css";
import Select from "react-select";
import { ConvertPdfToImage } from "../../utils/ConvertPdfToImage";

function TariffCosting() {
  const shipmentUploadFileInputRef = useRef(null);
  const params = useParams();
  const shipment_id = params?.id
  const [shipmentData, setShipmentData] = useState("");
  const [shipmentExist, setShipmentExist] = useState(false);

  const [showDraftBookingLoader, setShowDraftBookingLoader] = useState(false);
  const [tarrifChargeDataPending, setTarrifChargeDataPending] = useState(false);
  const [enableSearchButton, setEnableSearchButton] = useState(false);
  const [portList, setPortList] = useState([]);
  const [terminalList, setTerminalList] = useState([]);
  const [vesselScheduleList, setVesselScheduleList] = useState([]);
  const [shipmentTypeList, setShipmentTypeList] = useState([
                                                            {"value": "THROUGH", "label":"THROUGH"}, 
                                                            {"value": "VIA", "label":"VIA"}, 
                                                            {"value": "DIRECT", "label":"DIRECT"}
                                                          ]);
  const [containerSizeList, setContainerSizeList] = useState([]);
  const [cargoTypeList, setCargoTypeList] = useState([
                                            {"value": "HAZARDOUS", "label":"HAZARDOUS"},
                                            {"value": "NON_HAZARDOUS", "label":"NON_HAZARDOUS"},
                                            {"value": "MIX_HAZARDOUS", "label":"MIX_HAZARDOUS"},
                                            {"value": "EMPTY", "label":"EMPTY"}
                                            ]);
  const [onAccountList, setOnAccountList] = useState([
                                            {"value": "SHIPPER", "label":"SHIPPER"},
                                            {"value": "CONSIGNEE", "label":"CONSIGNEE"}
                                            ]);
                                          
  const [commodityList, setCommodityList] = useState([]);
  const [principalList, setPrincipalList] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [salesUserList, setSalesUserList] = useState([]);
  const [operatorList, setOperatorList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [chargeList, setChargeList] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const [transhipmentList, setTranshipmentList] = useState([]);
  const [slotRateList, setSlotRateList] = useState([]);

  const [blTypeList, setBlTypeList] = useState([
                                                {"value": "ORIGINAL", "label":"ORIGINAL"},
                                                {"value": "SEA_WAY", "label":"SEA_WAY"},
                                                {"value": "SURRENDER", "label":"SURRENDER"}
                                              ]);
  const [blSubTypeList, setBlSubTypeList] = useState([
                                                      {"value": "NA", "label":"NA"},
                                                      {"value": "PART_BL", "label":"PART_BL"},
                                                      {"value": "SWITCH_BL", "label":"SWITCH_BL"}
                                                    ]);
  
  const [paymentTypeList, setPaymentTypeList] = useState([
                                                      {"value": "COLLECT", "label":"COLLECT"},
                                                      {"value": "PREPAID", "label":"PREPAID"}
                                                    ]);  
                        
                                                  
  // ----------- Add State Variables
  const [selectedPoa, setSelectedPoa] = useState("");
  const [selectedPol, setSelectedPol] = useState("");
  const [selectedPolTerminal, setSelectedPolTerminal] = useState("");
  const [selectedPod, setSelectedPod] = useState("");
  const [selectedFd, setSelectedFd] = useState("");
  const [selectedVesselSchedule, setSelectedVesselSchedule] = useState("");
  const [selectedShipmentType, setSelectedShipmentType] = useState("");
  const [showTranshipment, setShowTranshipment] = useState(false);
  const [selectedTranshipment, setSelectedTranshipment] = useState("");
  const [selectedPrincipal, setSelectedPrincipal] = useState("");
  const [selectedBookingAgent, setSelectedBookingAgent] = useState("");
  const [selectedDeliveryAgent, setSelectedDeliveryAgent] = useState("");
  const [selectedBookingParty, setSelectedBookingParty] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [shipper, setShipper] = useState("");
  const [selectedBlType, setSelectedBlType] = useState("");
  const [selectedBlSubType, setSelectedBlSubType] = useState("");
  const [switchAt, setSwitchAt] = useState("")
  const [collectAt, setCollectAt] = useState("") 
  const [onAccount, setOnAccount] = useState("") 
  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const [selectedSlotOperator, setSelectedSlotOperator] = useState("");
  const [selectedSlotPaymentAgent, setSelectedSlotPaymentAgent] = useState("");
  const [selectedSalesPerson, setSelectedSalesPerson] = useState("");
  const [selectedRateApprovedBy, setSelectedRateApprovedBy] = useState("");
  const [selectedSpaceConfirmedBy, setSelectedSpaceConfirmedBy] = useState("");
  const [poaFreeDays, setPoaFreeDays] = useState(7);
  const [podFreeDays, setPodFreeDays] = useState(14);
  const [importLocal, setImportLocal] = useState([]);
  const [importLocalData, setImportLocalData] = useState([]);
  const [exportLocal, setExportLocal] = useState([]);
  const [exportLocalData, setExportLocalData] = useState([]);
  const [marginPerImport, setMarginPerImport] = useState(0.0);
  const [marginPerExport, setMarginPerExport] = useState(0.0);
  const [remarks, setRemarks] = useState("");


  // ----------- Update State Variables
  const [updateSelectedPoa, setUpdateSelectedPoa] = useState("");
  const [updateSelectedPol, setUpdateSelectedPol] = useState("");
  const [updateSelectedPolTerminal, setUpdateSelectedPolTerminal] = useState("");
  const [updateSelectedPod, setUpdateSelectedPod] = useState("");
  const [updateSelectedFd, setUpdateSelectedFd] = useState("");
  const [updateSelectedVesselSchedule, setUpdateSelectedVesselSchedule] = useState("");
  const [updateSelectedShipmentType, setUpdateSelectedShipmentType] = useState("");
  const [updateSelectedTranshipment, setUpdateSelectedTranshipment] = useState("");
  const [transhipmentPortsForUpdate, setTranshipmentPortsForUpdate] = useState([]);
  const [transhipmentUpdatePorts, setTranshipmentUpdatePorts] = useState([]);

  const [updateSelectedPrincipal, setUpdateSelectedPrincipal] = useState("");
  const [updateSelectedBookingAgent, setUpdateSelectedBookingAgent] = useState("");
  const [updateSelectedDeliveryAgent, setUpdateSelectedDeliveryAgent] = useState("");
  const [updateSelectedBookingParty, setUpdateSelectedBookingParty] = useState("");
  const [updateSelectedCustomer, setUpdateSelectedCustomer] = useState("");
  const [updateShipper, setUpdateShipper] = useState("");
  const [updateSelectedBlType, setUpdateSelectedBlType] = useState("");
  const [updateSelectedBlSubType, setUpdateSelectedBlSubType] = useState("");
  const [updateSwitchAt, setUpdateSwitchAt] = useState("")
  const [updateCollectAt, setUpdateCollectAt] = useState("") 
  const [updateOnAccount, setUpdateOnAccount] = useState("") 
  const [updateSelectedPaymentType, setUpdateSelectedPaymentType] = useState("");
  const [updateSelectedSlotOperator, setUpdateSelectedSlotOperator] = useState("");
  const [updateSelectedSlotPaymentAgent, setUpdateSelectedSlotPaymentAgent] = useState("");
  const [updateSelectedSalesPerson, setUpdateSelectedSalesPerson] = useState("");
  const [updateSelectedRateApprovedBy, setUpdateSelectedRateApprovedBy] = useState("");
  const [updateSelectedSpaceConfirmedBy, setUpdateSelectedSpaceConfirmedBy] = useState("");
  const [updatePoaFreeDays, setUpdatePoaFreeDays] = useState(7);
  const [updatePodFreeDays, setUpdatePodFreeDays] = useState(14);
  const [updateImportLocal, setUpdateImportLocal] = useState([]);
  const [updateImportLocalData, setUpdateImportLocalData] = useState([]);
  const [updateExportLocal, setUpdateExportLocal] = useState([]);
  const [updateExportLocalData, setUpdateExportLocalData] = useState([]);
  const [updateMarginPerImport, setUpdateMarginPerImport] = useState(0.0);
  const [updateMarginPerExport, setUpdateMarginPerExport] = useState(0.0);
  const [updateRemarks, setUpdateRemarks] = useState("");
  const [updateStatus, setUpdateStatus] = useState("");
  const [updateBookingLineItem, setUpdateBookingLineItem] = useState([]);
  const [bookingLineItemLoader, setBookingLineItemLoader] = useState(false);
  const [updateShipmentUploads, setUpdateShipmentUploads] = useState([]);
  const [updateShippingId, setUpdateShippingId] = useState("");
  const [shipmentUploadsPerPage, setShipmentUploadsPerPage] = useState(5);
  

  const setShipmentDataForUpdate = (data) => {
    setUpdateSelectedPoa(data?.poa_data)
    setUpdateSelectedPol(data?.pol_data)
    setUpdateSelectedPolTerminal(data?.pol_terminal_data)
    setUpdateSelectedPod(data?.pod_data)
    setUpdateSelectedFd(data?.fd_data)
    setUpdateSelectedVesselSchedule({"value": data?.first_vessel_schedule_data?.id, "label": data?.first_vessel_schedule_data?.vessel_data?.name +" - "+ data?.first_vessel_schedule_data?.eta_date})
    setUpdateSelectedShipmentType(data?.shipment_type)
    setUpdateSelectedPrincipal({"value": data?.principal_data?.id, "label": data?.principal_data?.name})
    setUpdateSelectedBookingAgent({"value": data?.booking_agent_data?.id, "label": data?.booking_agent_data?.name})
    setUpdateSelectedDeliveryAgent({"value": data?.delivery_agent_data?.id, "label": data?.delivery_agent_data?.name})
    setUpdateSelectedBookingParty({"value": data?.booking_party_data?.id, "label": data?.booking_party_data?.name})
    setUpdateSelectedCustomer({"value": data?.customer_data?.id, "label": data?.customer_data?.name})
    setUpdateShipper(data?.shipper)
    setUpdateSelectedBlType({"value": data?.bl_type, "label": data?.bl_type})
    setUpdateSelectedBlSubType({"value": data?.bl_sub_type, "label": data?.bl_sub_type})
    setUpdateSwitchAt({"value": data?.switch_at_data?.id, "label": data?.switch_at_data?.name})
    setUpdateCollectAt({"value": data?.collect_at_data?.id, "label": data?.collect_at_data?.name}) 
    setUpdateOnAccount({"value": data?.on_account, "label": data?.on_account}) 
    setUpdateSelectedPaymentType({"value": data?.payment, "label": data?.payment})
    setUpdateSelectedSlotOperator({"value": data?.slot_operator_data?.id, "label": data?.slot_operator_data?.name})
    setUpdateSelectedSlotPaymentAgent({"value": data?.slot_payment_agent_data?.id, "label": data?.slot_payment_agent_data?.name})
    setUpdateSelectedSalesPerson({"value": data?.sales_person_data?.id, "label": data?.sales_person_data?.name})
    setUpdateSelectedRateApprovedBy({"value": data?.rate_approved_by_data?.id, "label": data?.rate_approved_by_data?.name})
    setUpdateSelectedSpaceConfirmedBy({"value": data?.space_confirmed_by_data?.id, "label": data?.space_confirmed_by_data?.name})
    setUpdatePoaFreeDays(data?.poa_detention_free_days)
    setUpdatePodFreeDays(data?.pod_detention_free_days)
    setUpdateRemarks(data?.remarks)
    setUpdateStatus(data?.status)

    getBookingLineItem(data?.id)
    getShipmentUploads(data?.id)
    // setUpdateImportLocal(data?.total_import_local_amount)
    // setUpdateImportLocalData(data?.)
    // setUpdateExportLocal(data?.total_export_local_amount)
    // setUpdateExportLocalData(data?.)
    // setUpdateMarginPerImport(data?.approximate_mpi) 
    // setUpdateMarginPerExport(data?.approximate_mpe) 
    

    // setUpdateSelectedTranshipment(data?.)
    // setTranshipmentPortsForUpdate(data?.)
    // setTranshipmentUpdatePorts(data?.)
  }

  useEffect(() => {
    if(shipmentExist){
      getTariffCharges()
    }
  }, [shipmentExist]);

  const getShipment = async (id) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/shipment/'+id);
      if (response) {
        setShipmentData(response.data)
        if(response?.data){
          setShipmentExist(true)
          setShipmentDataForUpdate(response?.data)
        }
      }
    } catch (err) {
      toast.error("Error in fetching shipment data! Try again.");
    }
  }

  const getShipmentUploads = async (id) => {
    try {
      setShipmentUploadDataPending(true)
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentdocument?shipment='+id);
      if (response) {
        setUpdateShipmentUploads(response.data)
      }
      setShipmentUploadDataPending(false)
    } catch (err) {
      toast.error("Error in fetching shipment documents! Try again.");
    }
  }

  useEffect(() => {
    if(shipment_id != undefined){
      getShipment(shipment_id)
    }
  }, [shipment_id]);
  

  const [showAddImportModal, setShowAddImportModal] = useState(false);
  const [showAddExportModal, setShowAddExportModal] = useState(false);

  const [showRouteError, setShowRouteError] = useState(false);
  const [showStakeholderError, setShowStakeholderError] = useState(false);
  const [showBlError, setShowBlError] = useState(false);
  const [showLogisticError, setShowLogisticError] = useState(false);
  const [poaFreeDaysError, setPoaFreeDaysError] = useState(false);
  const [podFreeDaysError, setPodFreeDaysError] = useState(false);

  const [routeFormOpen, setRouteFormOpen] = useState(false);
  const [cargoFormOpen, setCargoFormOpen] = useState(false);
  const [stakeholderFormOpen, setStakeholderFormOpen] = useState(false);
  const [chargesFormOpen, setChargesFormOpen] = useState(false);
  const [logisticFormOpen, setLogisticFormOpen] = useState(false);
  const [handlingFormOpen, setHandlingFormOpen] = useState(false);

  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });

  const triggerRouteFormRef = useRef(null);
  const triggerCargoFormRef = useRef(null);
  const triggerStakeholderFormRef = useRef(null);
  const triggerChargesFormRef = useRef(null);
  const triggerLogisticFormRef = useRef(null);
  const triggerHandlingFormRef = useRef(null);

  const tooltipRouteFormRef = useRef(null);
  const tooltipCargoFormRef = useRef(null);
  const tooltipStakeholderFormRef = useRef(null);
  const tooltipChargesFormRef = useRef(null);
  const tooltipLogisticFormRef = useRef(null);
  const tooltipHandlingFormRef = useRef(null);

  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [submitOption, setSubmitOption] = useState("draft");
  const [updateOption, setUpdateOption] = useState("draft");
  const [multipleBookingCount, setMultipleBookingCount] = useState(2);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] = useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const user_role = sessionStorage['userrole']
  const user_id = sessionStorage['id']
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [userCustomer, setUserCustomer] = useState([]);
  

  // =========================================== Cargo Rows ============================================
  const [cargoRows, setCargoRows] = useState([
    {
      id: Date.now(),
      container_size: "",
      quantity: 0,
      weight: 0,
      slot: 0,
      freight_indication: 0,
      cargo_type: "",
      commodity: "",
      currency: ""
    },
  ]);

  const addRow = () => {
    setCargoRows([
      ...cargoRows,
      {
        id: Date.now(),
        container_size: "",
        quantity: 0,
        weight: 0,
        slot: 0,
        freight_indication: 0,
        cargo_type: "",
        commodity: "",
        currency: ""
      },
    ]);
  };

  const removeRow = (id) => {
    setCargoRows(cargoRows.filter((row) => row.id !== id));
  };

  const handleChange = (index, id, field, value) => {
    cargoRows[index][field] = value;
    setCargoRows(cargoRows);
  };

  const refreshRows = () => {
    addRow()
    setCargoRows(cargoRows => cargoRows.slice(0, -1))
  }

  // ============================================ Add New Import Charge ===================================================
  const [importChargeRows, setImportChargeRows] = useState([
    {
      id: Date.now(),
      product_data:"Adhoc",
      product_name: "Adhoc",
      charge_data:"",
      charge_name: "",
      amount: 0.0,
      expense: 0.0,
      amount_type: "",
      charge_basis: "",
      currency_data: "",
      currency: "",
      quantity: 0,
      total: 0.0,
      requested: 0.0,
      approved: 0.0,
      approved_by: ""
    },
  ]);

  const addImportChargeRow = () => {
    setImportChargeRows([
      ...importChargeRows,
      {
        id: Date.now(),
        product_data:"Adhoc",
        product_name: "Adhoc",
        charge_name: "",
        amount: 0.0,
        expense: 0.0,
        amount_type: "",
        charge_basis: "",
        currency_data: "",
        currency: "",
        quantity: 0,
        total: 0.0,
        requested: 0.0,
        approved: 0.0,
        approved_by: ""
      },
    ]);
  };

  const removeImportChargeRow = (id) => {
    setImportChargeRows(importChargeRows.filter((row) => row.id !== id));
  };

  const handleImportChargeChange = (index, id, field, value) => {
    importChargeRows[index][field] = value;
    setImportChargeRows(importChargeRows);
  };

  const clearImportChargeRow = () => {
    setImportChargeRows([
    {
      id: Date.now(),
      product_data:"Adhoc",
      product_name: "Adhoc",
      charge_data:"",
      charge_name: "",
      amount: 0.0,
      expense: 0.0,
      amount_type: "",
      charge_basis: "",
      currency_data: "",
      currency: "",
      quantity: 0,
      total: 0.0,
      requested: 0.0,
      approved: 0.0,
      approved_by: ""
    },
  ]);
  }

  // ============================================ Add New Export Charge ===================================================
  const [exportChargeRows, setExportChargeRows] = useState([
    {
      id: Date.now(),
      product_data:"Adhoc",
      product_name: "Adhoc",
      charge_data:"",
      charge_name: "",
      amount: 0.0,
      expense: 0.0,
      amount_type: "",
      charge_basis: "",
      currency_data: "",
      currency: "",
      quantity: 0,
      total: 0.0,
      requested: 0.0,
      approved: 0.0,
      approved_by: ""
    },
  ]);

  const addExportChargeRow = () => {
    setExportChargeRows([
      ...exportChargeRows,
      {
        id: Date.now(),
        product_data:"Adhoc",
        product_name: "Adhoc",
        charge_name: "",
        amount: 0.0,
        expense: 0.0,
        amount_type: "",
        charge_basis: "",
        currency_data: "",
        currency: "",
        quantity: 0,
        total: 0.0,
        requested: 0.0,
        approved: 0.0,
        approved_by: ""
      },
    ]);
  };

  const removeExportChargeRow = (id) => {
    setExportChargeRows(exportChargeRows.filter((row) => row.id !== id));
  };

  const handleExportChargeChange = (index, id, field, value) => {
    exportChargeRows[index][field] = value;
    setExportChargeRows(exportChargeRows);
  };

  const clearExportChargeRow = () => {
    setExportChargeRows([
    {
      id: Date.now(),
      product_data:"Adhoc",
      product_name: "Adhoc",
      charge_data:"",
      charge_name: "",
      amount: 0.0,
      expense: 0.0,
      amount_type: "",
      charge_basis: "",
      currency_data: "",
      currency: "",
      quantity: 0,
      total: 0.0,
      requested: 0.0,
      approved: 0.0,
      approved_by: ""
    },
  ]);
  }

  // ============================================ Document Uploads ============================================
  const [updateId, setUpdateId] = useState("");
  const [uploadFiles, setUploadFiles] = useState([]);
  const [showUploadFilesLoader, setShowUploadFilesLoader] = useState(false);
  const [draftbookingUploads, setDraftbookingUploads] = useState(false);
  const [shipmentUploadDataPending, setShipmentUploadDataPending] = useState(false);
  const [deleteShippingUploadModal, setDeleteShippingUploadModal] = useState(false);
  const [uploadFilesSerialNumber, setUploadFilesSerialNumber] = useState(false);
  const [deleteUploadFileName, setDeleteShippingUploadFileName] = useState(false);
  const [showDeleteUploadFilesLoader, setShowDeleteShippingUploadFilesLoader] = useState(false);
  
  // ============================================ Document Uploads ============================================

  const getCurrentUserRolePermission = async (roles) => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/role/getuserrolepermission?roles='+roles);
        
        const role_permissions_array = []
        for(let i=0; i<response.data?.length; i++){
            for(let j=0; j<response?.data[i]?.permissions_array?.length; j++){
                if(!role_permissions_array.includes(response?.data[i]?.permissions_array?.[j])){
                    role_permissions_array.push(response?.data[i]?.permissions_array?.[j])
                }
            }
        }

        if(role_permissions_array){
            setCurrentUserRolePermissionData(role_permissions_array)
        }
          
    } catch (err) {
        toast.error("Error in fetching user role data! Try again.");
    }
  }

  const getLoggenInUser = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/user/' + user_id);
      if (response) {
        setLoggedInUser(response.data)
        console.log("response.data", response.data.customer)
        getCustomer(response.data?.customer)
      }
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  }

  const getPort = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/port/');
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.name, }));
        setPortList(data)
      }
    } catch (err) {
      toast.error("Error in fetching port data! Try again.");
    }
  }

  const getTerminal = async (selectedPort) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/terminal?port='+selectedPort.value);
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.name, }));
        setTerminalList(data)
      }
    } catch (err) {
      toast.error("Error in fetching terminal data! Try again.");
    }
  }

  const getVesselSchedule = async (pickup_port, pick_terminal, destination_port) => {
    try {
      if(pickup_port.value !="" && pick_terminal.value !="" && destination_port.value !=""){
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/vesselschedule?pick_port='+pickup_port.value+'&pick_terminal='+pick_terminal.value+'&next_port='+destination_port.value);
        if (response) {
          const data = response.data.map(item => ({ value: item.id, label: item.vessel_data.name +" - " + item.eta_date, }));
          setVesselScheduleList(data)
        }
      }
    } catch (err) {
      // toast.error("Error in fetching vessel schedule data! Try again.");
    }
  }

  const getContainerSize = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/product?type=CONTAINER');
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.product_name, }));
        setContainerSizeList(data)
      }
    } catch (err) {
      toast.error("Error in fetching container size data! Try again.");
    }
  }

  const getCommodity = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/cargo');
      if (response) {
        const data = response.data.map(item => ({ value: item.name, label: item.name, }));
        setCommodityList(data)
      }
    } catch (err) {
      toast.error("Error in fetching commodity data! Try again.");
    }
  }

  const getUser = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/user');
      if (response) {
        const sales_user = response.data.filter(user => user.role_array.includes('sales'));
        const data = response.data.map(item => ({ value: item.id, label: item.name, }));
        const sales_user_data = sales_user.map(item => ({ value: item.id, label: item.name, }));
        setUserList(data)
        setSalesUserList(sales_user_data)
      }
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  }

  const getOperator = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/operator');
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.name, }));
        setOperatorList(data)
      }
    } catch (err) {
      toast.error("Error in fetching operator data! Try again.");
    }
  }

  const getCustomer = async (user_customer) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/customer/getusercustomer?customer_list='+user_customer);
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.name, }));
        setCustomerList(data)
      }
    } catch (err) {
      toast.error("Error in fetching customer data! Try again.");
    }
  }


  const getTariffCharges = async () => {
    if(shipmentExist){
        try {
        setTarrifChargeDataPending(false)
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/tariffcharge?tariff__poa='+updateSelectedPoa?.id+'&tariff__pol='+updateSelectedPol?.id+'&tariff__pol_terminal='+updateSelectedPolTerminal?.id+'&tariff__pod='+updateSelectedPod?.id+'&tariff__fd='+updateSelectedFd?.id);

        if (response) {
          const importLocalCharges = response.data.filter(charge => charge.charge_category == "IMPORT_LOCAL").map(charge => ({
                                                                                                                              product_data: charge?.product_data,
                                                                                                                              product_name: charge?.product_data?.product_name,
                                                                                                                              charge_name: charge?.charge_name,
                                                                                                                              amount: charge?.amount,
                                                                                                                              expense: charge?.expense,
                                                                                                                              amount_type: charge?.amount_type || "", 
                                                                                                                              charge_basis: charge?.charge_basis || "",
                                                                                                                              currency_data: charge?.currency_data,
                                                                                                                              currency: charge?.currency_data?.symbol || "",
                                                                                                                              quantity: 1,
                                                                                                                              total: 0.0,
                                                                                                                              requested: 0.0,
                                                                                                                              approved: 0.0,
                                                                                                                              approved_by: ""
                                                                                                                            }));

          const exportLocalCharges = response.data.filter(charge => charge.charge_category == "EXPORT_LOCAL").map(charge => ({
                                                                                                                              product_data: charge?.product_data,
                                                                                                                              product_name: charge?.product_data?.product_name,
                                                                                                                              charge_name: charge?.charge_name,
                                                                                                                              amount: charge?.amount,
                                                                                                                              expense: charge?.expense,
                                                                                                                              amount_type: charge?.amount_type || "", 
                                                                                                                              charge_basis: charge?.charge_basis || "",
                                                                                                                              currency_data: charge?.currency_data,
                                                                                                                              currency: charge?.currency_data?.symbol || "",
                                                                                                                              quantity: 1,
                                                                                                                              total: 0.0,
                                                                                                                              requested: 0.0,
                                                                                                                              approved: 0.0,
                                                                                                                              approved_by: ""
                                                                                                                            }));

          setImportLocal(importLocalCharges)
          setImportLocalData(importLocalCharges)

          var mpi = 0
          var total_import_charge = 0
          var total_import_expense = 0
          for(let i=0; i<importLocalCharges.length; i++){
            if(importLocalCharges[i]['amount_type'] == 'AMOUNT'){
              total_import_charge += importLocalCharges[i]['amount']
              total_import_expense += importLocalCharges[i]['expense']
            }
          }
          mpi = total_import_charge - total_import_expense
          setMarginPerImport(mpi)

          setExportLocal(exportLocalCharges)
          setExportLocalData(exportLocalCharges)

          var mpe = 0
          var total_export_charge = 0
          var total_export_expense = 0
          for(let i=0; i<exportLocalCharges.length;i++){
            if(exportLocalCharges[i]['amount_type'] == 'AMOUNT'){
              total_export_charge += exportLocalCharges[i]['amount']
              total_export_expense += exportLocalCharges[i]['expense']
            }
          }
          mpe = total_export_charge - total_export_expense
          setMarginPerExport(mpe)

          setTarrifChargeDataPending(false)
        }
      } catch (err) {
        toast.error("Error in fetching operator data! Try again.");
      }
    }
    else{
      try {
        setTarrifChargeDataPending(false)
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/tariffcharge?tariff__poa='+selectedPoa.value+'&tariff__pol='+selectedPol.value+'&tariff__pol_terminal='+selectedPolTerminal.value+'&tariff__pod='+selectedPod.value+'&tariff__fd='+selectedFd.value);

        if (response) {
          const importLocalCharges = response.data.filter(charge => charge.charge_category == "IMPORT_LOCAL").map(charge => ({
                                                                                                                              product_data: charge?.product_data,
                                                                                                                              product_name: charge?.product_data?.product_name,
                                                                                                                              charge_name: charge?.charge_name,
                                                                                                                              amount: charge?.amount,
                                                                                                                              expense: charge?.expense,
                                                                                                                              amount_type: charge?.amount_type || "", 
                                                                                                                              charge_basis: charge?.charge_basis || "",
                                                                                                                              currency_data: charge?.currency_data,
                                                                                                                              currency: charge?.currency_data?.symbol || "",
                                                                                                                              quantity: 1,
                                                                                                                              total: 0.0,
                                                                                                                              requested: 0.0,
                                                                                                                              approved: 0.0,
                                                                                                                              approved_by: ""
                                                                                                                            }));

          const exportLocalCharges = response.data.filter(charge => charge.charge_category == "EXPORT_LOCAL").map(charge => ({
                                                                                                                              product_data: charge?.product_data,
                                                                                                                              product_name: charge?.product_data?.product_name,
                                                                                                                              charge_name: charge?.charge_name,
                                                                                                                              amount: charge?.amount,
                                                                                                                              expense: charge?.expense,
                                                                                                                              amount_type: charge?.amount_type || "", 
                                                                                                                              charge_basis: charge?.charge_basis || "",
                                                                                                                              currency_data: charge?.currency_data,
                                                                                                                              currency: charge?.currency_data?.symbol || "",
                                                                                                                              quantity: 1,
                                                                                                                              total: 0.0,
                                                                                                                              requested: 0.0,
                                                                                                                              approved: 0.0,
                                                                                                                              approved_by: ""
                                                                                                                            }));

          setImportLocal(importLocalCharges)
          setImportLocalData(importLocalCharges)

          var mpi = 0
          var total_import_charge = 0
          var total_import_expense = 0
          for(let i=0; i<importLocalCharges.length; i++){
            if(importLocalCharges[i]['amount_type'] == 'AMOUNT'){
              total_import_charge += importLocalCharges[i]['amount']
              total_import_expense += importLocalCharges[i]['expense']
            }
          }
          mpi = total_import_charge - total_import_expense
          setMarginPerImport(mpi)

          setExportLocal(exportLocalCharges)
          setExportLocalData(exportLocalCharges)

          var mpe = 0
          var total_export_charge = 0
          var total_export_expense = 0
          for(let i=0; i<exportLocalCharges.length;i++){
            if(exportLocalCharges[i]['amount_type'] == 'AMOUNT'){
              total_export_charge += exportLocalCharges[i]['amount']
              total_export_expense += exportLocalCharges[i]['expense']
            }
          }
          mpe = total_export_charge - total_export_expense
          setMarginPerExport(mpe)

          setTarrifChargeDataPending(false)
        }
      } catch (err) {
        toast.error("Error in fetching operator data! Try again.");
      }
    }
  }

  const getBookingLineItem = async (shipment_id) => {
    try {
      setBookingLineItemLoader(true)
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/bookinglineitem/getbookinglineitemsforupdate?shipment_id='+shipment_id);
      
      if (response?.data) {
        const booking_line_items_array = response.data.map(item => ({
          id: item?.id,
          container_size: item?.container_type_data,
          quantity: item?.container_quantity,
          weight: item?.weight,
          slot: item?.slot,
          freight_indication: item?.freight_indication,
          cargo_type: item?.cargo_type,
          commodity: item?.commodity_data,
          currency: item?.currency_data
        }));

        setUpdateBookingLineItem(booking_line_items_array)
        setBookingLineItemLoader(false)
      }
    } catch (err) {
      toast.error("Error in fetching booking line items! Try again.");
    }
  }

  const getProduct = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/product');
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.product_name, }));
        setProductList(data)
      }
    } catch (err) {
      toast.error("Error in fetching product data! Try again.");
    }
  }

  const getCharge = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/charge');
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.name, }));
        setChargeList(data)
      }
    } catch (err) {
      toast.error("Error in fetching charge data! Try again.");
    }
  }

  const getCurrency = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/currency');
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.symbol +" ("+item.name+")", }));
        setCurrencyList(data)
      }
    } catch (err) {
      toast.error("Error in fetching charge data! Try again.");
    }
  }

  const getTrashipmentPort = async (from, to, vessel_schedule) => {
    if(from?.value != "" | from?.value != undefined){
      if(to?.value != "" | to?.value != undefined){
        if(vessel_schedule?.value != undefined ){
          const vessel_schedule_response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/vesselschedule/'+vessel_schedule.value)
          const vessel = vessel_schedule_response.data?.vessel
          try {
              const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/transhipment?from_port='+from.value+'&to_port='+to.value+'&vessel='+vessel);
              if (response) {
                const data = response.data.map(item => ({ value: item.id, label: item.via_port_data.name, }));
                setTranshipmentList(data)
              }
            } catch (err) {
              toast.error("Error in fetching transhipment data! Try again.");
            }
          }
        else{
          toast.warning("Select Vessel Schedule before proceeding! Try again.");
        }
      }
      else{
          toast.warning("Select FD before proceeding! Try again.");
      }
    }
    else{
      toast.warning("Select POA before proceeding! Try again.");
    }
  }

  const getSlotAgreement = async (from_port, to_port, operator) => {
    if(from_port?.value != ""){
      if(to_port?.value != ""){
        if(operator != undefined || operator != ""){
          try {
            const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/slotagreement?from_port='+from_port.value+'&to_port='+to_port.value+'&operator='+operator);
            if (response.data) {
              const agreement_id = response.data[0]?.id
              const slot_rate_response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/slotrate?slot_agreement='+agreement_id);
              setSlotRateList(slot_rate_response.data)
            }
          } catch (err) {
            toast.error("Error in fetching transhipment data! Try again.");
          }
        }
        else{
          toast.error("Operator Not Found");
        }
      }
      else{
        toast.error("Select Destination Port i.e. FD");
      }
    }
    else{
        toast.error("Select Origin Port i.e. POL");
    }
  }

  const getSlotRate = async (row, index) => {
    const container_type = row['container_size']?.['label']
    const cargo_type = row['cargo_type']
    const quantity = row['quantity']

    if(container_type != ""){
      if(cargo_type != ""){
        try {
            const slot_rate = slotRateList.filter(slot => slot.container_type_data?.product_name == container_type && slot.cargo_type == cargo_type);
            cargoRows[index].currency = slot_rate?.[0]?.['currency_data']?.['symbol']
            cargoRows[index].slot = slot_rate?.[0]?.['rate']
            cargoRows[index].freight_indication = parseFloat(slot_rate?.[0]?.['rate']) * parseFloat(quantity)
            setCargoRows(cargoRows)
            refreshRows()
          } catch (err) {
            toast.error("Error in fetching slot rate data! Try again.");
          }
      }
    }
  }

  const saveAdhocImportCharges = () => {
    setShowAddImportModal(false)
    const combinedCharges = [...importLocal, ...importChargeRows];
    setImportLocal(combinedCharges)
    clearImportChargeRow()
  }

  const saveAdhocExportCharges = () => {
    setShowAddExportModal(false)
    const combinedCharges = [...exportLocal, ...exportChargeRows];
    setExportLocal(combinedCharges)
    clearExportChargeRow()
  }

  const removeChargeExpense = () => {

  }

  const localchargescolumns = [
    {
      name: 'Product',
      selector: row => <span className={`${row.product_data == "Adhoc"?"bg-warning px-2 rounded":""}`}>{row.product_data == "Adhoc"? row.product_data: row.product_data?.product_name}</span>,
      sortable: true,
    },
    {
      name: 'Charge',
      selector: row => row.charge_name,
      width: "300px",
      sortable: true,
    },
    {
      name: 'Amount',
      selector: row => row.amount_type == 'PERCENTAGE'? row.amount + " %": row.amount + " x " + row.quantity,
      sortable: true,
    },
    {
      name: 'Total',
      selector: row => 
        <>
        <span>{row.product_data == "Adhoc"? row.currency?.label[0]: row.currency_data?.symbol}</span>
        <span> {row.amount_type == 'PERCENTAGE'? row.amount + " %": row.amount}</span>
        </>,
      sortable: true,
    },
    // {
    //   name: 'Negotiation',
    //   selector: row => 
    //     <>
    //       <span>Requested: {row.product_data == "Adhoc"? row.currency?.label[0]: row.currency_data?.symbol} {row.amount}</span><br></br>
    //       <span>Approved: {row.product_data == "Adhoc"? row.currency?.label[0]: row.currency_data?.symbol} {row.amount}</span>
    //     </>,
    //   sortable: true,
    // }
  ];

  // ---------------------- Route Form ---------------------------
  const handleRouteFormClick = () => {
    const rect = triggerRouteFormRef.current.getBoundingClientRect();
    setTooltipPosition({
      top: rect.bottom + window.scrollY + 10,
      left: rect.left + window.scrollX + rect.width / 3,
    });
    setRouteFormOpen(true);
  };

  useEffect(() => {
    function handleRouteFormOutsideClick(e) {
      if (
        tooltipRouteFormRef.current &&
        !tooltipRouteFormRef.current.contains(e.target) &&
        !triggerRouteFormRef.current.contains(e.target)
      ) {
        setRouteFormOpen(false);
        setShowRouteError(true);
      }
    }
    document.addEventListener("mousedown", handleRouteFormOutsideClick);
    return () => document.removeEventListener("mousedown", handleRouteFormOutsideClick);
  }, []);

  // ---------------------- Cargo Form ---------------------------
  const handleCargoFormClick = () => {
    const rect = triggerCargoFormRef.current.getBoundingClientRect();
    setTooltipPosition({
      top: rect.bottom + window.scrollY + 10,
      left: rect.left + window.scrollX + rect.width / 3,
    });
    setCargoFormOpen(true);
    console.log("cargoRows", cargoRows)
    setCargoRows(cargoRows);
  };

  useEffect(() => {
    function handleCargoFormOutsideClick(e) {
      if (
        tooltipCargoFormRef.current &&
        !tooltipCargoFormRef.current.contains(e.target) &&
        !triggerCargoFormRef.current.contains(e.target)
      ) {
        setCargoFormOpen(false);
      }
    }
    document.addEventListener("mousedown", handleCargoFormOutsideClick);
    return () => document.removeEventListener("mousedown", handleCargoFormOutsideClick);
  }, []);

  // ---------------------- Stakeholder Form ---------------------------
  const handleStakeholderFormClick = () => {
    const rect = triggerStakeholderFormRef.current.getBoundingClientRect();
    setTooltipPosition({
      top: rect.bottom + window.scrollY + 10,
      left: rect.left + window.scrollX + rect.width / 3,
    });
    setStakeholderFormOpen(true);
  };

  useEffect(() => {
    function handleStakeholderFormOutsideClick(e) {
      if (
        tooltipStakeholderFormRef.current &&
        !tooltipStakeholderFormRef.current.contains(e.target) &&
        !triggerStakeholderFormRef.current.contains(e.target)
      ) {
        setStakeholderFormOpen(false);
        setShowStakeholderError(true);
      }
    }
    document.addEventListener("mousedown", handleStakeholderFormOutsideClick);
    return () => document.removeEventListener("mousedown", handleStakeholderFormOutsideClick);
  }, []);

  // ---------------------- Charges Form ---------------------------
  const handleChargesFormClick = () => {
    const rect = triggerChargesFormRef.current.getBoundingClientRect();
    setTooltipPosition({
      top: rect.bottom + window.scrollY + 10,
      left: rect.left + window.scrollX + rect.width / 3,
    });
    setChargesFormOpen(true);
  };

  useEffect(() => {
    function handleChargesFormOutsideClick(e) {
      if (
        tooltipChargesFormRef.current &&
        !tooltipChargesFormRef.current.contains(e.target) &&
        !triggerChargesFormRef.current.contains(e.target)
      ) {
        setChargesFormOpen(false);
        setShowBlError(true);
      }
    }
    document.addEventListener("mousedown", handleChargesFormOutsideClick);
    return () => document.removeEventListener("mousedown", handleChargesFormOutsideClick);
  }, []);


  useEffect(() => {
    getLoggenInUser()
    getPort()
    getOperator()
    getUser()
    getContainerSize()
    getCommodity()
    getProduct()
    getCharge()
    getCurrency()
  }, []);
  

  useEffect(() => {
    getCurrentUserRolePermission(user_role)
  }, [user_role]);

  const customRouteValidationStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: !state.hasValue && showRouteError ? 'red' : base.borderColor,
      boxShadow: 'none',
      '&:hover': {
        borderColor: !state.hasValue && showRouteError ? 'red' : base.borderColor
      },
    }),
  };

  const customStakeholderValidationStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: !state.hasValue && showStakeholderError ? 'red' : base.borderColor,
      boxShadow: 'none',
      '&:hover': {
        borderColor: !state.hasValue && showStakeholderError ? 'red' : base.borderColor
      },
    }),
  };

  //  ----------------------------------------------- Uploads  -----------------------------------------------------

  const shipmentuploadcolumns = [
    {
      name: 'Preview',
      selector: row => 
        <>
          {row.file_type == 'application/pdf'?
          <img className="img" style={{ border: '1px solid lightgrey'}} src={`${row.screenshot}`} width={100}></img>
          :
          <img className="img" style={{ border: '1px solid lightgrey'}} src={`${row.file}`} width={100}></img>
          }
        </>
        ,
      width: '150px',
      sortable: true,
    },
    {
      name: 'File Name',
      selector: row => row.file_name + row.file,
      width: '300px',
      sortable: true,
    },
    {
      name: 'Document Category',
      selector: row => row.document_category.replaceAll("_", " "),
      sortable: true,
    },
    {
      name: 'File Type',
      selector: row => row.file_type,
      sortable: true,
    },
    {
      name: 'File Size',
      selector: row => row.file_size + " MB",
      sortable: true,
    },
    {
      name: 'Uploaded By',
      selector: row => row.created_by?.name,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      selector: row => <div>
        {
          currentUserRolePermissionData?.includes("draftbooking:customerdraftshipmentdocument:delete") ?
            <Button className="btn btn-sm bg-danger border-0 mx-2" title="Delete" onClick={() => setDeleteUploadDetails(row)}>
              <i className="fa fa-trash"></i>
            </Button>
            :
            ""
        }

        {
          currentUserRolePermissionData?.includes("draftbooking:customerdraftshipmentdocument:view") ?
            <a href={`${row.file}`} target="_blank">
              <Button className="btn btn-sm btn-inox-green border-0 mx-2" title="View">
                <i className="fa fa-eye"></i>
              </Button>
            </a>
            :
            ""
        }
      </div>,
    }
  ];

  const createUploadFiles = async (files) => {
    const uploadFiles = await Promise.all(
      Array.from(files).map(async (file) => {
        const screenshot = file.type === "application/pdf"
          ? await ConvertPdfToImage(file)
          : "";

        return {
          file,
          previewUrl: URL.createObjectURL(file),
          custom_category: "",
          screenshot
        };
      })
    );

    return uploadFiles;
  };
  
  const handleUploadsFileChange = async (files) => {
    const uploadfiles = await createUploadFiles(files);
    setUploadFiles(uploadfiles);
    console.log("uploadfiles", uploadfiles)
  }

  const setCustomCategoryToDocument = (file, category) => {
    file.custom_category = category
    console.log("uploadfiles", uploadFiles)
  }

  const removeDocument = (index_to_remove) => {
    URL.revokeObjectURL(uploadFiles[index_to_remove].previewUrl);
    setUploadFiles(files => files.filter((_, index) => index !== index_to_remove));
  }

  const addShipmentUploads = async (e) => {
    e.preventDefault();
    setShowUploadFilesLoader(true)
    const id = updateId
    const empty_category = uploadFiles.some(file => file.custom_category === "");
    if (empty_category){
      toast.error("Assign category to all documents")
      setShowUploadFilesLoader(false)
    }
    else{
      const data = {
        id: id,
        shipment: shipment_id,
        upload: uploadFiles,
        created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
      }
  
      const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentdocument/shipmentuploads/', data,
        {
          headers: { 'content-type': 'multipart/form-data' }
        }
      );
      if (response.status === 200) {
        toast.success("Files Uploaded Successfully")
      }
  
      setUploadFiles([])
      getShipmentUploads(shipment_id)
      shipmentUploadFileInputRef.current.value = null;
      setShowUploadFilesLoader(false)
    }
  }

  const setDeleteUploadDetails = (row) => {
    setDeleteShippingUploadModal(true)
    setUpdateShippingId(row.id)
    setDeleteShippingUploadFileName(row.file_name)
  }

  const deleteShippingUploads = async (e) => {
    e.preventDefault();
    setShowDeleteShippingUploadFilesLoader(true)

    const document_id = updateShippingId

    const response = await axios.delete(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentdocument/'+document_id+'/',
      {
        headers: { 'content-type': 'application/json' }
      }
    );

    if (response.status === 204) {
      toast.success("File Deleted Successfully")
      getShipmentUploads(shipment_id)
    }

    setShowDeleteShippingUploadFilesLoader(false)
    setDeleteShippingUploadModal(false)
  }

  //  ----------------------------------------------- Uploads  -----------------------------------------------------

  useEffect(() => {
    if(selectedPoa && selectedPol && selectedPolTerminal && selectedPod && selectedFd && selectedCustomer){
      setEnableSearchButton(true)
    }
    else{
      setEnableSearchButton(false)
    }
  }, [selectedPoa, selectedPol, selectedPolTerminal, selectedPod, selectedFd, selectedCustomer]);


  const addNewBooking = async (e) => {
    e.preventDefault();
    setShowDraftBookingLoader(true)

    const data = {
      poa: selectedPoa?.value,
      pol: selectedPol?.value,
      pol_terminal: selectedPolTerminal?.value,
      pod: selectedPod?.value,
      fd: selectedFd?.value,
      reference_number: "",
      customer: selectedCustomer?.value,
      iec_code: "",
      shipper: shipper,
      remarks: remarks,
      weight: cargoRows.reduce((sum, row) => sum + Number(row.weight || 0), 0),
      slot_operator: selectedSlotOperator?.value,
      total_import_local_amount: importLocal.reduce((sum, row) => sum + Number(row.amount * row.quantity || 0), 0) * 0.012,
      total_export_local_amount: exportLocal.reduce((sum, row) => sum + Number(row.amount * row.quantity || 0), 0) * 0.012,
      total_import_local_expense: importLocal.reduce((sum, row) => sum + Number(row.expense * row.quantity || 0), 0) * 0.012,
      total_export_local_expense: exportLocal.reduce((sum, row) => sum + Number(row.expense * row.quantity || 0), 0) * 0.012,
      status: "DRAFT",
      line_booking_item: cargoRows,
      submit_option: submitOption, 
      multiple_booking_count: multipleBookingCount,
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
      last_booking_number: process.env.REACT_APP_LAST_BOOKING_NUMBER
    }

    const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL+'/master/shipment/createdraftbooking/', data,  
      {
        headers: { 'content-type': 'application/json'}
      }
    );

    if (response.status == 200 ) {
      if(data.status == "DRAFT"){
        toast.success("New Draft Created Successfully")
      }
      else if(data.status == "WAITING_APPROVAL"){
        toast.success("New Booking Created Successfully. Approval Pending")
      }
    }
    setShowDraftBookingLoader(false)
  }

  function handleDataFromTopNavBar(permissiondata) {
    setDataFromTopNavBar(permissiondata);
  }

  return (
    <div className="page-content-bg">
      <ToastContainer></ToastContainer>
      <TopNavbar sidebarCollapsed={menuDrawerShow} topNavbarStatic={true} sendDataToParent={handleDataFromTopNavBar} />
      <SideNavbar sidebarCollapsed={menuDrawerShow} activeMenu="DraftBooking" activeSubMenu="TariffCosting" activeSubMenuLevel1="" permissionFromTopNavbar={dataFromTopNavBar} />

      <div className={menuDrawerShow ? "row main-content-collapsed text-left py-0" : "row main-content text-left py-0"} >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-sm-4 col-md-4 col-lg-6 py-1">
              <Button className="btn btn-sm btn-inox-green border-0 mx-2" onClick={() => setMenuDrawerShow(!menuDrawerShow)}>
                {menuDrawerShow ?
                  <span><i className="fa fa-chevron-left mx-1"></i></span> :
                  <span><i className="fa fa-chevron-right mx-1"></i></span>
                }
              </Button>
              <span className="page-header-text">Draft Booking</span>
            </div>
          </div>

          <div className="row" style={{ marginRight: 35 }}>
            <div class="col-12 border rounded shadow mt-3" style={{ marginLeft: 18 }}>
              <div className="d-flex my-3">
                <div class="p-2 flex-grow-1">
                  <h5 className="fw-bold">Route</h5>
                  <input 
                    ref={triggerRouteFormRef} 
                    type="text" 
                    className="form-control form-control-sm border-0" 
                    placeholder="Shipping From and To" 
                    onClick={handleRouteFormClick}
                  />
                  
                  {shipmentExist?
                    <div className="bg-whhite pt-3" style={{ fontSize: 12 }}>
                      <span><b>POA: </b> {updateSelectedPoa?.name ?? "None"}</span><br></br>
                      <span><b>POL: </b> {updateSelectedPol.name ?? "None"}</span><br></br>
                      <span><b>POL Terminal: </b> {updateSelectedPolTerminal.name ?? "None"}</span><br></br>
                      <span><b>POD: </b> {updateSelectedPod.name ?? "None"}</span><br></br>
                      <span><b>FD: </b> {updateSelectedFd.name ?? "None"}</span><br></br>
                    </div>
                    :
                    selectedPoa && selectedPol && selectedPolTerminal && selectedPod && selectedFd?
                    <div className="bg-whhite pt-3" style={{ fontSize: 12 }}>
                      <span><b>POA: </b> {selectedPoa.label ?? "None"}</span><br></br>
                      <span><b>POL: </b> {selectedPol.label ?? "None"}</span><br></br>
                      <span><b>POL Terminal: </b> {selectedPolTerminal.label ?? "None"}</span><br></br>
                      <span><b>POD: </b> {selectedPod.label ?? "None"}</span><br></br>
                      <span><b>FD: </b> {selectedFd.label ?? "None"}</span><br></br>
                    </div>
                    :""
                  }

                  {routeFormOpen && (
                    <div
                      ref={tooltipRouteFormRef}
                      className="tooltip-form-container"
                      style={{
                        top: tooltipPosition.top,
                        left: tooltipPosition.left,
                        transform: "translateX(-35%)",
                      }}
                    >
                      <div className="tooltip-arrow" />
                        <div className="tooltip-content px-3" style={{background: '#FFF' }}>
                          <form className="tooltip-form">
                            <div className="row">
                              <div className="col-12 px-0 font-12px mt-2">POA</div>
                              <div className="col-12 px-0">
                                <Select 
                                  options={portList} 
                                  id="poa" 
                                  name="poa" 
                                  onChange={(e) => setSelectedPoa(e)}
                                  value={shipmentExist?{'value': updateSelectedPoa?.id, 'label': updateSelectedPoa?.name}:selectedPoa}
                                  isMulti={false}
                                  isClearable
                                  className="px-0"
                                  placeholder={<span>POA <span style={{ color: 'red' }}>*</span></span>}
                                  styles={customRouteValidationStyles}
                                  isDisabled={shipmentExist}
                                />
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-7 px-0 font-12px mt-2">POL</div>
                              <div className="col-5 px-1 font-12px mt-2">POL Terminal</div>

                              <div className="col-7 px-0">
                                <Select 
                                  options={portList} 
                                  id="pol" 
                                  name="pol" 
                                  onChange={(e) => [setSelectedPol(e), 
                                                    getTerminal(e), 
                                                    getVesselSchedule(e, null, null),
                                                    getTrashipmentPort(e, selectedFd, selectedVesselSchedule)]}
                                  value={shipmentExist?{'value': updateSelectedPol?.id, 'label': updateSelectedPol?.name}:selectedPol}
                                  isMulti={false}
                                  isClearable
                                  className="px-0 flex-grow-1 mr-1"
                                  placeholder={<span>POL <span style={{ color: 'red' }}>*</span></span>}
                                  styles={customRouteValidationStyles}
                                  isDisabled={shipmentExist}
                                />
                              </div>

                              <div className="col-5 px-0">
                                <Select 
                                  options={terminalList} 
                                  id="pol_terminal" 
                                  name="pol_terminal" 
                                  onChange={(e) => [setSelectedPolTerminal(e), 
                                                    getVesselSchedule(selectedPol, e, null)]}
                                  value={shipmentExist?{'value': updateSelectedPolTerminal?.id, 'label': updateSelectedPolTerminal?.name}:selectedPolTerminal}
                                  isMulti={false}
                                  isClearable
                                  className="px-0 flex-grow-1 ml-1"
                                  placeholder={<span>POL Terminal <span style={{ color: 'red' }}>*</span></span>}
                                  styles={customRouteValidationStyles}
                                  isDisabled={shipmentExist}
                                />
                              </div>
                            </div>
                            
                            <div className="row">
                              <div className="col-12 px-0 font-12px mt-2">POD</div>
                              <div className="col-12 px-0">
                                <Select 
                                  options={portList} 
                                  id="pod" 
                                  name="pod" 
                                  onChange={(e) => setSelectedPod(e)}
                                  value={shipmentExist?{'value': updateSelectedPod?.id, 'label': updateSelectedPod?.name}:selectedPod}
                                  isMulti={false}
                                  isClearable
                                  className="px-0"
                                  placeholder={<span>POD <span style={{ color: 'red' }}>*</span></span>}
                                  styles={customRouteValidationStyles}
                                  isDisabled={shipmentExist}
                                />
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-12 px-0 font-12px mt-2">FD</div>
                              <div className="col-12 px-0">
                                <Select 
                                  options={portList} 
                                  id="fd" 
                                  name="fd" 
                                  onChange={(e) => [setSelectedFd(e), 
                                                    getVesselSchedule(selectedPol, selectedPolTerminal, e),
                                                    getTrashipmentPort(selectedPol, e, selectedVesselSchedule)]}
                                  value={shipmentExist?{'value': updateSelectedFd?.id, 'label': updateSelectedFd?.name}:selectedFd}
                                  isMulti={false}
                                  isClearable
                                  className="px-0"
                                  placeholder={<span>FD <span style={{ color: 'red' }}>*</span></span>}
                                  styles={customRouteValidationStyles}
                                  isDisabled={shipmentExist}
                                />
                              </div>
                            </div>

                            <div className="row">
                              <div class="d-flex text-center my-1 px-0">
                                <button type="button" 
                                        className="btn btn-secondary border-0 w-100" 
                                        style={{ marginRight: 5 }} onClick={() => [
                                                                                  setRouteFormOpen(false), 
                                                                                  setShowRouteError(false),
                                                                                  setSelectedPoa(""),
                                                                                  setSelectedPol(""),
                                                                                  setSelectedPolTerminal(""),
                                                                                  setSelectedPod(""),
                                                                                  setSelectedFd("")
                                                                                  ]}>Cancel</button>
                                <button className="btn btn-inox-green border-0 w-100 text-white" style={{ marginLeft: 5 }} onClick={() => setRouteFormOpen(false)}>Save</button>
                              </div>
                            </div>
                          </form>
                        </div>
                    </div>
                  )}
                </div>

                <div class="p-2 flex-grow-1">
                  <h5 className="fw-bold">Cargo and Container</h5>
                  <input 
                    ref={triggerCargoFormRef} 
                    type="text" 
                    className="form-control form-control-sm border-0" 
                    placeholder="What is being shipped?" 
                    onClick={handleCargoFormClick}
                  />
                  
                  <div className="mt-3" style={{ fontSize: 12 }}>
                    {shipmentExist?
                      <>
                        <span>
                          <b>Slot Operator: </b> {updateSelectedSlotOperator?.label ?? "None"}
                        </span><br></br>
                      </>
                    :
                      selectedSlotOperator != ""?
                        <>
                          <span>
                            <b>Slot Operator: </b> {selectedSlotOperator?.label ?? "None"}
                          </span><br></br>
                        </>
                      :""
                    }

                    {!shipmentExist && cargoRows.map((cargo, index) => (
                      <div style={{ fontSize: 13 }} class={`${cargoRows[index]['freight_indication']==""?"display-none":""}`}>
                        <hr className="my-1"></hr>
                        <small>{cargo.quantity} x {cargo.container_size.label} {cargo.commodity} ({cargo.cargo_type})</small><br></br>
                        <small>
                          <span>Slot: <b>{cargo.currency} {cargo.slot}</b></span>
                          <span className="mx-3"> Freight Indication: <b>{cargo.currency} {cargo.freight_indication}</b></span>
                        </small>
                      </div>
                    ))}

                    {!shipmentExist && cargoRows && cargoRows?.[0]?.freight_indication > 0?
                    <>
                      <hr className="my-1"></hr>
                      <span><b>Total Weight (KG): </b>{cargoRows.reduce((sum, row) => sum + Number(row.weight || 0), 0)}</span><br></br>
                      <span><b>Total Slot Charge: </b>{cargoRows.reduce((sum, row) => sum + Number(row.slot || 0), 0)}</span><br></br>
                      <span><b>Total Freight Indication: </b>{cargoRows.reduce((sum, row) => sum + Number(row.freight_indication || 0), 0)}</span>
                    </>
                    :""}


                    {shipmentExist && updateBookingLineItem.map((cargo, index) => (
                      <div style={{ fontSize: 13 }} class={`${cargo['freight_indication']==""?"display-none":""}`}>
                        <hr className="my-1"></hr>
                        <small>{cargo.quantity} x {cargo.container_size.label} {cargo.commodity?.name} ({cargo.cargo_type})</small><br></br>
                        <small>
                          <span>Slot: <b>{cargo.currency?.symbol} {cargo.slot}</b></span>
                          <span className="mx-3"> Freight Indication: <b>{cargo.currency?.symbol} {cargo.freight_indication}</b></span>
                        </small>
                      </div>
                    ))}

                    {shipmentExist && updateBookingLineItem && updateBookingLineItem?.[0]?.freight_indication > 0?
                    <>
                      <hr className="my-1"></hr>
                      <span><b>Total Weight (KG): </b>{updateBookingLineItem?.reduce((sum, row) => sum + Number(row.weight || 0), 0)}</span><br></br>
                      <span><b>Total Slot Charge: </b>{updateBookingLineItem?.reduce((sum, row) => sum + Number(row.slot || 0), 0)}</span><br></br>
                      <span><b>Total Freight Indication: </b>{updateBookingLineItem?.reduce((sum, row) => sum + Number(row.freight_indication || 0), 0)}</span>
                    </>
                    :""}
                  </div>

                  {cargoFormOpen && (
                    <div
                      ref={tooltipCargoFormRef}
                      className="tooltip-form-line-item-container"
                      style={{
                        top: tooltipPosition.top,
                        left: tooltipPosition.left,
                        transform: "translateX(-45%)",
                      }}
                    >
                      <div className="tooltip-arrow" />
                        <div className="tooltip-content px-3" style={{background: '#FFF' }}>
                          <div className="row">
                            <div className="col-4 px-0 mb-2">
                              <div className="col-12 px-0 font-12px mt-2">Slot Operator</div>
                              <div className="col-12 px-0">
                                <Select 
                                  options={operatorList} 
                                  id="slot_operator" 
                                  name="slot_operator" 
                                  onChange={(e) => {
                                                  if(shipmentExist){
                                                    setUpdateSelectedSlotOperator(e)
                                                    getSlotAgreement(updateSelectedPol?.id, 
                                                                      updateSelectedFd?.id, 
                                                                      e?.value)
                                                  }
                                                  else{
                                                    setSelectedSlotOperator(e)
                                                    getSlotAgreement(selectedPol, selectedFd, e?.value)
                                                  }
                                                }}
                                  value={shipmentExist?updateSelectedSlotOperator:selectedSlotOperator}
                                  isMulti={false}
                                  isClearable
                                  className="px-0 flex-grow-1"
                                  placeholder="Slot Operator"
                                />
                              </div>
                            </div>
                          </div>

                          {bookingLineItemLoader?
                          <div className="d-flex flex-column align-items-center justify-content-center mt-4 mb-5">
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                          </div>
                          :""
                          }

                          {shipmentExist?
                          updateBookingLineItem.map((row, index) => (
                          <form className={`tooltip-form ${index!=0?'mt-2':''}`}>
                            <div className="row">
                              <div class="d-flex px-0">
                                <Select 
                                  options={containerSizeList}
                                  id={"container_size" + index} 
                                  name={"container_size" + index}
                                  onChange={(e) => [
                                                    handleChange(index, row.id, "container_size", e),
                                                    getSlotRate(row, index)
                                                  ]}
                                  isMulti={false}
                                  isClearable
                                  className="px-0 flex-grow-1"
                                  placeholder={row['container_size']? row['container_size']['product_name']:"Container Size"}
                                />

                                <input 
                                  id={"quantity" + index} 
                                  name={"quantity" + index}
                                  type="number"
                                  placeholder={row['quantity']? row['quantity']:"Quantity"}
                                  className="flex-grow-1 ml-1"
                                  style={{ width: '100px', height: '39px' }}
                                  onChange={(e) => [
                                                    handleChange(index, row.id, "quantity", e.target.value),
                                                    getSlotRate(row, index)
                                                  ]}>
                                </input>

                                <Select 
                                  options={cargoTypeList}
                                  id={"cargo_type" + index} 
                                  name={"cargo_type" + index}
                                  onChange={(e) => [
                                                    handleChange(index, row.id, "cargo_type", e?.value),
                                                    getSlotRate(row, index)
                                                  ]}
                                  isMulti={false}
                                  isClearable
                                  className="px-0 flex-grow-1 ml-1"
                                  placeholder={row['cargo_type']? row['cargo_type']:"Cargo Type"}
                                />

                                <Select 
                                  options={commodityList}
                                  id={"commodity" + index} 
                                  name={"commodity" + index}
                                  onChange={(e) => handleChange(index, row.id, "commodity", e.value)}
                                  isMulti={false}
                                  isClearable
                                  className="px-0 flex-grow-1 ml-1"
                                  placeholder={row['commodity']? row['commodity']['name']:"Commodity"}
                                />

                                <input 
                                  id={"weight" + index} 
                                  name={"weight" + index}
                                  type="number"
                                  placeholder={row['weight']? row['weight']:"Weight (KG)"}
                                  className="flex-grow-1 ml-1"
                                  style={{ width: '120px', height: '39px' }}
                                  onChange={(e) => handleChange(index, row.id, "weight", e.target.value)}>
                                </input>

                                <input 
                                  id={"slot" + index} 
                                  name={"slot" + index}
                                  type="number"
                                  placeholder={row['slot']? row['slot']:"Slot"} 
                                  className="flex-grow-1 ml-1"
                                  style={{ width: '120px', background: '#CFCFCF', height: '39px' }}
                                  disabled
                                  >
                                </input>

                                <input 
                                  id={"freight_indication" + index} 
                                  name={"freight_indication" + index}
                                  type="number"
                                  placeholder={row['freight_indication']? row['freight_indication']:"Freight Indication"} 
                                  className="flex-grow-1 ml-1"
                                  style={{ background: '#CFCFCF', height: '39px' }}
                                  disabled
                                  >
                                </input>

                                <Button 
                                  className="flex-grow-1 btn btn-sm btn-inox-red ml-1 border-0"
                                  title="Remove Cargo"
                                  onClick={() => removeRow(row.id)}
                                  disabled={index == 0 ? true : false}>
                                    <i className="fa fa-trash"></i>
                                </Button>

                                <Button 
                                  className="flex-grow-1 btn btn-sm btn-inox-green ml-1 border-0"
                                  title="Add Cargo"
                                  onClick={() => addRow()}>
                                    <i className="fa fa-plus"></i>
                                </Button>
                              </div>
                            </div>
                          </form>
                          ))
                          :
                          selectedPol && selectedFd && selectedSlotOperator && cargoRows.map((row, index) => (
                          <form className={`tooltip-form ${index!=0?'mt-2':''}`}>
                            <div className="row">
                              <div class="d-flex px-0">
                                <Select 
                                  options={containerSizeList}
                                  id={"container_size" + index} 
                                  name={"container_size" + index}
                                  onChange={(e) => [
                                                    handleChange(index, row.id, "container_size", e),
                                                    getSlotRate(cargoRows[index], index)
                                                  ]}
                                  isMulti={false}
                                  isClearable
                                  className="px-0 flex-grow-1"
                                  placeholder={cargoRows[index]['container_size']? cargoRows[index]['container_size']['label']:"Container Size"}
                                />

                                <input 
                                  id={"quantity" + index} 
                                  name={"quantity" + index}
                                  type="number"
                                  placeholder={cargoRows[index]['quantity']? cargoRows[index]['quantity']:"Quantity"}
                                  className="flex-grow-1 ml-1"
                                  style={{ width: '100px' }}
                                  onChange={(e) => [
                                                    handleChange(index, row.id, "quantity", e.target.value),
                                                    getSlotRate(cargoRows[index], index)
                                                  ]}>
                                </input>

                                <Select 
                                  options={cargoTypeList}
                                  id={"cargo_type" + index} 
                                  name={"cargo_type" + index}
                                  onChange={(e) => [
                                                    handleChange(index, row.id, "cargo_type", e?.value),
                                                    getSlotRate(cargoRows[index], index)
                                                  ]}
                                  isMulti={false}
                                  isClearable
                                  className="px-0 flex-grow-1 ml-1"
                                  placeholder={cargoRows[index]['cargo_type']? cargoRows[index]['cargo_type']:"Cargo Type"}
                                />

                                <Select 
                                  options={commodityList}
                                  id={"commodity" + index} 
                                  name={"commodity" + index}
                                  onChange={(e) => handleChange(index, row.id, "commodity", e.value)}
                                  isMulti={false}
                                  isClearable
                                  className="px-0 flex-grow-1 ml-1"
                                  placeholder={cargoRows[index]['commodity']? cargoRows[index]['commodity']:"Commodity"}
                                />

                                <input 
                                  id={"weight" + index} 
                                  name={"weight" + index}
                                  type="number"
                                  placeholder={cargoRows[index]['weight']? cargoRows[index]['weight']:"Weight (KG)"}
                                  className="flex-grow-1 ml-1"
                                  style={{ width: '120px' }}
                                  onChange={(e) => handleChange(index, row.id, "weight", e.target.value)}>
                                </input>

                                <input 
                                  id={"slot" + index} 
                                  name={"slot" + index}
                                  type="number"
                                  placeholder={cargoRows[index]['slot']? cargoRows[index]['slot']:"Slot"} 
                                  className="flex-grow-1 ml-1"
                                  style={{ width: '120px', background: '#CFCFCF' }}
                                  disabled
                                  >
                                </input>

                                <input 
                                  id={"freight_indication" + index} 
                                  name={"freight_indication" + index}
                                  type="number"
                                  placeholder={cargoRows[index]['freight_indication']? cargoRows[index]['freight_indication']:"Freight Indication"} 
                                  className="flex-grow-1 ml-1"
                                  style={{ background: '#CFCFCF' }}
                                  disabled
                                  >
                                </input>

                                <Button 
                                  className="flex-grow-1 btn btn-sm btn-inox-red ml-1 border-0"
                                  title="Remove Cargo"
                                  onClick={() => removeRow(row.id)}
                                  disabled={index == 0 ? true : false}>
                                    <i className="fa fa-trash"></i>
                                </Button>

                                <Button 
                                  className="flex-grow-1 btn btn-sm btn-inox-green ml-1 border-0"
                                  title="Add Cargo"
                                  onClick={() => addRow()}>
                                    <i className="fa fa-plus"></i>
                                </Button>
                              </div>
                            </div>
                          </form>
                          ))
                          }
                          
                          <div className="row mt-3">
                            <div class="d-flex justify-content-center text-center my-1 px-0">
                              <button type="button" 
                                      className="btn btn-secondary border-0" 
                                      style={{ marginRight: 5, width: 200 }} 
                                      onClick={() => [
                                                      setCargoFormOpen(false),
                                                      setCargoRows([{
                                                        id: Date.now(),
                                                        container_size: "",
                                                        quantity: 1,
                                                        slot: 1,
                                                        freight_indication: 0,
                                                        cargo_type: "",
                                                        commodity: ""
                                                      }]),
                                                      setSelectedSlotOperator("")
                                                    ]}>Cancel</button>

                              <button className="btn btn-inox-green border-0 text-white" style={{ marginLeft: 5, width: 200 }} onClick={() => setCargoFormOpen(false)}>Save</button>
                            </div>
                          </div>
                        </div>
                    </div>
                  )}
                </div>

                <div class="p-2 flex-grow-1">
                  <h5 className="fw-bold">Stakeholders</h5>
                  <input 
                    ref={triggerStakeholderFormRef} 
                    type="text" 
                    className="form-control form-control-sm border-0" 
                    placeholder="Who is involved?" 
                    onClick={handleStakeholderFormClick}
                  />

                  {!shipmentExist && selectedCustomer?
                  <div className="bg-whhite pt-3" style={{ fontSize: 12 }}>
                    <span><b>Customer: </b> {selectedCustomer.label ?? "None"}</span><br></br>
                    <span><b>Shipper: </b> {shipper ?? "None"}</span><br></br>
                  </div>
                  :""
                  }

                  {shipmentExist?
                  <div className="bg-whhite pt-3" style={{ fontSize: 12 }}>
                    <span><b>Customer: </b> {updateSelectedCustomer.label ?? "None"}</span><br></br>
                    <span><b>Shipper: </b> {updateShipper ?? "None"}</span><br></br>
                  </div>
                  :""
                  }

                  {stakeholderFormOpen && (
                    <div
                      ref={tooltipStakeholderFormRef}
                      className="tooltip-form-container"
                      style={{
                        top: tooltipPosition.top,
                        left: tooltipPosition.left,
                        transform: "translateX(-35%)",
                      }}
                    >
                      <div className="tooltip-arrow" />
                        <div className="tooltip-content px-3" style={{background: '#FFF' }}>
                          <form className="tooltip-form">
                            <div className="row">
                              <div className="col-12 px-0 font-12px mt-2">Customer</div>
                              <div className="col-12 px-0">
                                <Select 
                                  options={customerList} 
                                  id="customer" 
                                  name="customer" 
                                  onChange={(e) => shipmentExist?setUpdateSelectedCustomer(e):setSelectedCustomer(e)}
                                  value={shipmentExist?updateSelectedCustomer:selectedCustomer}
                                  isMulti={false}
                                  isClearable
                                  className="px-0 flex-grow-1"
                                  placeholder={<span>Customer <span style={{ color: 'red' }}>*</span></span>}
                                  styles={customStakeholderValidationStyles}
                                />
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-12 px-0 font-12px mt-2">Shipper</div>
                              <div className="col-12 px-0">
                                <input type="text" 
                                  id="shipper" 
                                  name="shipper" 
                                  onChange={(e) => shipmentExist?setUpdateShipper(e.target.value):setShipper(e.target.value)}
                                  className="form-control flex-grow-1"
                                  placeholder="Shipper"
                                  styles={customStakeholderValidationStyles}
                                  value={shipmentExist?updateShipper:shipper}
                                />
                              </div>
                            </div>
                            
                            <div className="row">
                              <div class="d-flex text-center my-1 px-0">
                                <button type="button" 
                                        className="btn btn-secondary border-0 w-100" 
                                        style={{ marginRight: 5 }} onClick={() => [
                                                                                    setStakeholderFormOpen(false),
                                                                                    setShowStakeholderError(false),
                                                                                    setSelectedPrincipal(""),
                                                                                    setSelectedBookingAgent(""),
                                                                                    setSelectedDeliveryAgent(""),
                                                                                    setSelectedBookingParty(""),
                                                                                    setSelectedCustomer("")
                                                                                  ]}
                                                                                  >Cancel</button>

                                <button className="btn btn-inox-green border-0 w-100 text-white" style={{ marginLeft: 5 }} onClick={() => [setStakeholderFormOpen(false), setShowStakeholderError(false)]}>Save</button>
                              </div>
                            </div>
                          </form>
                        </div>
                    </div>
                  )}
                </div>

                <div class="p-2">
                  <Button className="btn btn-inox-green btn-sm border-0" style={{ marginTop: 30 }} onClick={() => getTariffCharges()}
                    disabled={enableSearchButton?false:true}>
                    <i className="fa fa-search"></i>
                  </Button>
                </div>
              </div>
            </div>

            <div class="col-12 mt-3 mb-5 px-0" style={{ marginLeft: 18 }}>
              <div className="flex-grow-1">
                <Accordion defaultActiveKey={['0']} alwaysOpen>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header width={1000}>
                      <div class="d-flex justify-content-end">
                        <span>Local Charges</span>
                        {shipmentExist?
                        <>
                          <span className="font-12px pt-1 mx-2" style={{ marginLeft: 1000 }}>( Import Charges: 
                            <b> ₹ {importLocal.reduce((sum, row) => sum + Number(row.amount * row.quantity || 0), 0).toFixed(2)}</b> or 
                            <b>  $ {(importLocal.reduce((sum, row) => sum + Number(row.amount * row.quantity || 0), 0) * 0.012).toFixed(2)}</b>
                            </span> 
                            | 
                          <span className="font-12px pt-1 mx-2">Export Charges: 
                            <b> ₹ {exportLocal.reduce((sum, row) => sum + Number(row.amount * row.quantity || 0), 0).toFixed(2)}</b>  or 
                            <b>  $ {(exportLocal.reduce((sum, row) => sum + Number(row.amount * row.quantity || 0), 0) * 0.012).toFixed(2)} )</b>
                          </span>
                        </>
                        :""}
                        </div>
                    </Accordion.Header>
                    <Accordion.Body className={`${importLocal.length > 0?"":"display-none"}`}>
                      <div className="row">
                        <div className="col-6">
                          <div className="row mb-3">
                            <div className="col-6">
                              <h5>Approximate Import Local Charges</h5>
                            </div>
                            <div className="col-6">
                              {
                              currentUserRolePermissionData?.includes("draftbooking:addcustomcharge:add")?
                              <Button className="btn btn-inox-green border-0 btn-sm float-right" onClick={() => setShowAddImportModal(true)}>Add Charge</Button>
                              :
                              ""
                              }
                            </div>
                          </div>

                          <Modal size="xl" dialogClassName="custom-modal-width" show={showAddImportModal} onHide={() => [setShowAddImportModal(false), clearImportChargeRow()]} centered>
                            <Modal.Header closeButton>
                              <Modal.Title>Add New Import Charge</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <div class="row tarrif-add-charge-form">
                                <div class="col-2 font-12px">Charge Name</div>
                                <div class="col-2 font-12px">Amount</div>
                                <div class="col-1 font-12px">Quantity</div>
                                <div class="col-2 font-12px">Requested</div>
                                <div class="col-2 font-12px">Approved</div>
                                <div class="col-2 font-12px">Currency</div>
                                <div class="col-1 font-12px text-center">Action</div>
                              </div>
                              
                              {importChargeRows.map((row, index) => (
                              <div class={`row tarrif-add-charge-form ${index!=0?'mt-2':''}`}>
                                <div class="col-2">
                                  <input type="text" 
                                    id={"import_charge_name"+index}
                                    name={"import_charge_name"+index}
                                    className="form-control" 
                                    placeholder={importChargeRows[index]['charge_name']? importChargeRows[index]['charge_name']:"Charge Name"}
                                    onChange={(e) => handleImportChargeChange(index, row.id, "charge_name", e.target.value)}
                                  />
                                </div>

                                <div class="col-2">
                                  <input 
                                    type="number"
                                    id={"import_charge_amount"+index}
                                    name={"import_charge_amount"+index} 
                                    className="form-control"
                                    placeholder={importChargeRows[index]['amount']? importChargeRows[index]['amount']:"Amount"}
                                    onChange={(e) => handleImportChargeChange(index, row.id, "amount", e.target.value)}
                                  />
                                </div>

                                <div class="col-1">
                                  <input 
                                    type="number" 
                                    id={"import_charge_quantity"+index}
                                    name={"import_charge_quantity"+index} 
                                    className="form-control" 
                                    placeholder={importChargeRows[index]['quantity']? importChargeRows[index]['quantity']:"Quantity"}
                                    onChange={(e) => handleImportChargeChange(index, row.id, "quantity", e.target.value)}
                                  />
                                </div>

                                <div class="col-2">
                                  <input 
                                    type="number" 
                                    id={"import_charge_requested"+index}
                                    name={"import_charge_requested"+index} 
                                    className="form-control" 
                                    placeholder={importChargeRows[index]['requested']? importChargeRows[index]['requested']:"Requested"}
                                    onChange={(e) => handleImportChargeChange(index, row.id, "requested", e.target.value)}
                                    disabled
                                  />
                                </div>

                                <div class="col-2">
                                  <input 
                                    type="number" 
                                    id={"import_charge_approved"+index}
                                    name={"import_charge_approved"+index} 
                                    className="form-control" 
                                    placeholder={importChargeRows[index]['approved']? importChargeRows[index]['approved']:"Approved"}
                                    onChange={(e) => handleImportChargeChange(index, row.id, "approved", e.target.value)}
                                    disabled
                                  />
                                </div>

                                <div class="col-2">
                                  <Select 
                                    options={currencyList} 
                                    id={"import_charge_currency"+index}
                                    name={"import_charge_currency"+index}  
                                    onChange={(e) => handleImportChargeChange(index, row.id, "currency", e)}
                                    isMulti={false}
                                    isClearable
                                    className="px-0"
                                    placeholder="Currency"
                                  />
                                </div>

                                <div class="col-1 px-0 text-center">
                                  <Button 
                                    className="btn btn-danger mx-1"
                                    title="Remove Cargo"
                                    onClick={() => removeImportChargeRow(row.id)}
                                    disabled={index == 0 ? true : false}
                                  >
                                      <i className="fa fa-trash"></i>
                                  </Button>

                                  <Button 
                                    className="btn btn-inox-green border-0"
                                    title="Add Charge"
                                    onClick={() => addImportChargeRow()}
                                  >
                                      <i className="fa fa-plus"></i>
                                  </Button>
                                </div>
                              </div>
                              ))}
                            </Modal.Body>
                            <Modal.Footer>
                              <Button variant="secondary" style={{ width: 150 }} onClick={() => [setShowAddImportModal(false), clearImportChargeRow()]}>Close</Button>
                              <Button class="btn btn-inox-green border-0 text-white" style={{ width: 150 }} onClick={() => saveAdhocImportCharges()}>Add Charges</Button>
                            </Modal.Footer>
                          </Modal>
                          

                          <DataTable
                            columns={localchargescolumns}
                            data={importLocal.filter(item => item.amount != 0)}
                            progressPending={tarrifChargeDataPending}
                            progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true"/>}
                            noDataComponent={<p className="text-center">No Import Charges Found</p>}
                            pagination
                            highlightOnHover
                            fixedHeader
                            dense
                            customStyles={importExportTableCustomStyles}
                          />
                        </div>

                        <div className="col-6">
                          <div className="row mb-3">
                            <div className="col-6">
                              <h5>Approximate Export Local Charges</h5>
                            </div>
                            <div className="col-6">
                              {
                              currentUserRolePermissionData?.includes("draftbooking:addcustomcharge:add")?
                              <Button className="btn btn-inox-green border-0 btn-sm float-right" onClick={() => setShowAddExportModal(true)}>Add Charge</Button>
                              :
                              ""
                              }
                            </div>
                          </div>

                          <Modal size="xl" dialogClassName="custom-modal-width" show={showAddExportModal} onHide={() => [setShowAddExportModal(false), clearExportChargeRow()]} centered>
                            <Modal.Header closeButton>
                              <Modal.Title>Add New Export Charge</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <div class="row tarrif-add-charge-form">
                                <div class="col-2 font-12px">Charge Name</div>
                                <div class="col-2 font-12px">Amount</div>
                                <div class="col-1 font-12px">Quantity</div>
                                <div class="col-2 font-12px">Requested</div>
                                <div class="col-2 font-12px">Approved</div>
                                <div class="col-2 font-12px">Currency</div>
                                <div class="col-1 font-12px text-center">Action</div>
                              </div>
                              
                              {exportChargeRows.map((row, index) => (
                              <div class={`row tarrif-add-charge-form ${index!=0?'mt-2':''}`}>
                                <div class="col-2">
                                  <input type="text" 
                                    id={"export_charge_name"+index}
                                    name={"export_charge_name"+index}
                                    className="form-control" 
                                    placeholder={exportChargeRows[index]['charge_name']? exportChargeRows[index]['charge_name']:"Charge Name"}
                                    onChange={(e) => handleExportChargeChange(index, row.id, "charge_name", e.target.value)}
                                  />
                                </div>

                                <div class="col-2">
                                  <input 
                                    type="number"
                                    id={"export_charge_amount"+index}
                                    name={"export_charge_amount"+index} 
                                    className="form-control"
                                    placeholder={exportChargeRows[index]['amount']? exportChargeRows[index]['amount']:"Amount"}
                                    onChange={(e) => handleExportChargeChange(index, row.id, "amount", e.target.value)}
                                  />
                                </div>

                                <div class="col-1">
                                  <input 
                                    type="number" 
                                    id={"export_charge_quantity"+index}
                                    name={"export_charge_quantity"+index} 
                                    className="form-control" 
                                    placeholder={exportChargeRows[index]['quantity']? exportChargeRows[index]['quantity']:"Quantity"}
                                    onChange={(e) => handleExportChargeChange(index, row.id, "quantity", e.target.value)}
                                  />
                                </div>

                                <div class="col-2">
                                  <input 
                                    type="number" 
                                    id={"export_charge_requested"+index}
                                    name={"export_charge_requested"+index} 
                                    className="form-control" 
                                    placeholder={exportChargeRows[index]['requested']? exportChargeRows[index]['requested']:"Requested"}
                                    onChange={(e) => handleExportChargeChange(index, row.id, "requested", e.target.value)}
                                    disabled
                                  />
                                </div>

                                <div class="col-2">
                                  <input 
                                    type="number" 
                                    id={"export_charge_approved"+index}
                                    name={"export_charge_approved"+index} 
                                    className="form-control" 
                                    placeholder={exportChargeRows[index]['approved']? exportChargeRows[index]['approved']:"Approved"}
                                    onChange={(e) => handleExportChargeChange(index, row.id, "approved", e.target.value)}
                                    disabled
                                  />
                                </div>

                                <div class="col-2">
                                  <Select 
                                    options={currencyList} 
                                    id={"export_charge_currency"+index}
                                    name={"export_charge_currency"+index}  
                                    onChange={(e) => handleExportChargeChange(index, row.id, "currency", e)}
                                    isMulti={false}
                                    isClearable
                                    className="px-0"
                                    placeholder="Currency"
                                  />
                                </div>

                                <div class="col-1 px-0 text-center">
                                  <Button 
                                    className="btn btn-danger mx-1"
                                    title="Remove Cargo"
                                    onClick={() => removeExportChargeRow(row.id)}
                                    disabled={index == 0 ? true : false}
                                  >
                                      <i className="fa fa-trash"></i>
                                  </Button>

                                  <Button 
                                    className="btn btn-inox-green border-0"
                                    title="Add Charge"
                                    onClick={() => addExportChargeRow()}
                                  >
                                      <i className="fa fa-plus"></i>
                                  </Button>
                                </div>
                              </div>
                              ))}
                            </Modal.Body>
                            <Modal.Footer>
                              <Button variant="secondary" style={{ width: 150 }} onClick={() => [setShowAddExportModal(false), clearExportChargeRow()]}>Close</Button>
                              <Button class="btn btn-inox-green border-0 text-white" style={{ width: 150 }} onClick={() => saveAdhocExportCharges()}>Add Charges</Button>
                            </Modal.Footer>
                          </Modal>

                          <DataTable
                            columns={localchargescolumns}
                            data={exportLocal.filter(item => item.amount != 0)}
                            progressPending={tarrifChargeDataPending}
                            progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true"/>}
                            noDataComponent={<p className="text-center">No Export Charges Found</p>}
                            pagination
                            highlightOnHover
                            fixedHeader
                            dense
                            customStyles={importExportTableCustomStyles}
                          />
                        </div>

                        <div className="col-6">
                          <h5>Total Import Charges (Approximate): 
                            <b> ₹ {importLocal.reduce((sum, row) => sum + Number(row.amount * row.quantity || 0), 0)}</b> or 
                            <b> $ {(importLocal.reduce((sum, row) => sum + Number(row.amount * row.quantity || 0), 0)) * 0.012}</b><br></br>

                            {!shipmentExist && cargoRows && cargoRows?.[0]?.freight_indication > 0?
                            <>Total Freight Indication: 
                              <b> ₹ {(cargoRows.reduce((sum, row) => sum + Number(row.freight_indication || 0), 0))}</b> or
                              <b> $ {(cargoRows.reduce((sum, row) => sum + Number(row.freight_indication || 0), 0)) * 0.012}</b> 
                            </>
                            :
                            ""
                            }

                            {shipmentExist && updateBookingLineItem && updateBookingLineItem?.[0]?.freight_indication > 0?
                            <>Total Freight Indication: 
                              <b> ₹ {(updateBookingLineItem?.reduce((sum, row) => sum + Number(row.freight_indication || 0), 0))}</b> or
                              <b> $ {(updateBookingLineItem?.reduce((sum, row) => sum + Number(row.freight_indication || 0), 0)) * 0.012}</b>
                            </>
                            :
                            ""
                            }
                          </h5>
                        </div>
                        <div className="col-6">
                          <h5>Total Export Charges (Approximate): 
                            <b> ₹ {exportLocal.reduce((sum, row) => sum + Number(row.amount * row.quantity || 0), 0)}</b> or 
                            <b> $ {(exportLocal.reduce((sum, row) => sum + Number(row.amount * row.quantity || 0), 0)) * 0.012}</b>
                          </h5>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TariffCosting;